import React from "react";
import { reportIcons } from "../../../../../shared/Data/reportIcons";
import { Form } from "react-bootstrap";

export function IconSelector({ iconState, onChange }) {
  console.log('iconselector', reportIcons)
  return (
    <Form.Control as="select" multiple value={iconState} onChange={function (evt) {
      onChange(Array.from(evt.target.selectedOptions).map(opt=>opt.value))
      // console.log('IconSelector onSelect', )
    }}>
      {reportIcons.map(icon => <option value={icon._name}>{icon._mask}</option>)}
    </Form.Control>
  )
}